import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Tabs, Typography, Spin, Row, Col, Input, message } from "antd";
import { Queries, Mutations } from "../../../../graphql";
import Container from "../../../../components/user/Container";
import TabsBlockProFile from "../../../../components/user/TabsBlockProFile";
import {
  datasetsProfileDetail,
  tabProfile,
} from "../../../../config/datasetsProfile";
import { checkType } from "../../../../utils/checkType";
import { pushAge, pushAgeWork } from "../../../../utils/formatdate";
import moment from "moment";

const { TabPane } = Tabs;
const { Text, Title } = Typography;

const newsDataProfile = "";

class ProFileDetail extends Component {
  state = {
    detailProfile: [],
    detailEmployee: [],
    dataNewProfile: {},
    loaddingDataNews: false,
    detailEmployeeDisplayConfig: null,
    loadingFullpage: true
  };

  fetchProfile = async () => {
    try {
      const { client, location } = this.props;

      const { data, errors } = await client.query({
        query: Queries.detchProfileListDetail,
      });

      console.log('detailProfile', data);

      this.setState({
        detailProfile: data,
      });

      await this.fetchEmployeeDetail(data?.fetchEmployeeProfile.empCode);
    } catch (error) {
       console.log("detailProfile", error)
      // const errorMessage = error.graphQLErrors[0].message
      // message.error("Token is expired.")
    }
  };

  fetchEmployeeDetail = async (searchUser) => {
    try {
      const { client, location } = this.props;

      const { data, errors } = await client.query({
        query: Queries.fetchEmployeeDetail,
        variables: {
          empCode: searchUser,
        },
      });

      let fetchEmployeeDetailDisplayConfig = data.fetchEmployeeDetail.displayConfig.filter(
        (item) => item.screenName === "profile"
      )

      console.log("detailEmployeeDisplayConfig query", data.fetchEmployeeDetail.displayConfig);

      this.setState({
        detailEmployee: data.fetchEmployeeDetail,
        detailEmployeeDisplayConfig:fetchEmployeeDetailDisplayConfig[0],
        loadingFullpage: false
      });
    } catch (error) {
      // const errorMessage = error.graphQLErrors[0].message
      // message.error("Token is expired.")
    }
  };

  inputForm = (title, values, keyInput) => {
    return (
      (keyInput == "input" && (
        <Col xs={24} sm={12} className="mb-4">
          <div className="">
            <Text>{title}</Text>
            <br></br>
            <Input
              value={values ? values : "ไม่พบข้อมูล"}
              className={values ? values : "font-italic"}
              disabled={true}
            />
          </div>
        </Col>
      )) || (
        <Col xs={24} sm={12} className="mb-4">
          <div className="">
            <Text>{title}</Text>
            <br></br>
            <Input.TextArea
              value={values ? values : "ไม่พบข้อมูล"}
              className={values ? values : "font-italic"}
              autoSize="2"
              disabled={true}
            />
          </div>
        </Col>
      )
    );
  };

  checkRefCarpark = (values) => {
    if (values.refCarpark) {
      return values.refCarpark.textTh;
    } else {
      return values.carpark;
    }
  };

  tabsOne = () => {
    const { detailProfile, detailEmployee, detailEmployeeDisplayConfig } = this.state;
    console.log(detailProfile);
    console.log(detailEmployee);
    console.log("detailEmployeeDisplayConfig", detailEmployeeDisplayConfig);
    return (
         <TabPane tab={"ข้อมูลบุคลากร"} key="1" className="mb-0">
         <Row gutter={16} type="flex" justify="left" align="top">
            <Col xs={24} md={24} className="mb-2">
               <strong className="color-red">ข้อมูลบุคลากร</strong>
            </Col>
            <>
               {this.inputForm(
               "ชื่อ",
               detailProfile.fetchProfile
                  ? detailProfile.fetchProfile.name
                     ? detailProfile.fetchProfile.name
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "รหัสบุคลากร",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.empCode
                     ? detailProfile.fetchEmployeeProfile.empCode
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "ประเภทบุคลากร",
               detailProfile.fetchEmployeeEmplGroup
                  ? detailProfile.fetchEmployeeEmplGroup.emplGrupName
                     ? detailProfile.fetchEmployeeEmplGroup.emplGrupName
                     : ""
                  : "",
               "input"
               )}
               
               {console.log("detailEmployeeDisplayConfig in",detailEmployeeDisplayConfig)}
               {detailEmployeeDisplayConfig?.showLv &&
               detailEmployeeDisplayConfig?.showLv > 0 &&
               this.inputForm(
                  detailEmployeeDisplayConfig?.lv1
                     ? detailEmployeeDisplayConfig?.lv1
                     : "",
                  //  'สำนัก',
                  detailProfile.fetchProfile
                     ? detailProfile.fetchProfile.organizationName
                     ? detailProfile.fetchProfile.organizationName
                     : ""
                     : "",
                  "TextArea"
               )}

               {detailEmployeeDisplayConfig?.showLv &&
               detailEmployeeDisplayConfig?.showLv > 1 &&
               this.inputForm(
                  detailEmployeeDisplayConfig?.lv2
                     ? detailEmployeeDisplayConfig?.lv2
                     : "",
                  // "ฝ่าย",
                  detailProfile.fetchProfile
                     ? detailProfile.fetchProfile.divisionName
                     ? detailProfile.fetchProfile.divisionName
                     : ""
                     : "",
                  "TextArea"
               )}

               {detailEmployeeDisplayConfig?.showLv &&
               detailEmployeeDisplayConfig?.showLv > 2 &&
               this.inputForm(
                  detailEmployeeDisplayConfig?.lv3
                     ? detailEmployeeDisplayConfig?.lv3
                     : "",
                  // "หน่วยงาน",
                  detailProfile.fetchProfile
                     ? detailProfile.fetchProfile.agencyName
                     ? detailProfile.fetchProfile.agencyName
                     : ""
                     : "",
                  "TextArea"
               )}
               {detailEmployeeDisplayConfig?.showLv &&
               detailEmployeeDisplayConfig?.showLv > 3 &&
               this.inputForm(
                  detailEmployeeDisplayConfig?.lv4
                     ? detailEmployeeDisplayConfig?.lv4
                     : "",
                  // "งาน/หอผู้ป่วย",
                  detailEmployee.subDeptName ? detailEmployee.subDeptName : "",
                  "TextArea"
               )}

               {detailEmployeeDisplayConfig?.showLv &&
               detailEmployeeDisplayConfig?.showLv > 4 &&
               this.inputForm(
                  detailEmployeeDisplayConfig?.lv5
                     ? detailEmployeeDisplayConfig?.lv5
                     : "",
                  detailEmployee.childSubDeptName
                     ? detailEmployee.childSubDeptName
                     : "",
                  "TextArea"
               )}

               {this.inputForm(
               "หน่วยงานต้นสังกัด",
               detailProfile.fetchProfile
                  ? detailProfile.fetchProfile.affAgencyName
                     ? detailProfile.fetchProfile.affAgencyName
                     : ""
                  : "",
               "TextArea"
               )}

               {this.inputForm(
               "ระดับ/กลุ่มย่อย",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.workingProfile.empLevel
                     .emplLevelName
                     ? detailProfile.fetchEmployeeProfile.workingProfile.empLevel
                        .emplLevelName
                     : ""
                  : "",
               "TextArea"
               )}

               {this.inputForm(
               "ตําแหน่งตามสายงาน",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.workingProfile.orgPosition
                     .positionName
                     ? detailProfile.fetchEmployeeProfile.workingProfile
                        .orgPosition.positionName
                     : ""
                  : "",
               "TextArea"
               )}

               {this.inputForm(
               "ตําแหน่งทางบริหาร",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.workingProfile
                     .positionManage.posManageName
                     ? detailProfile.fetchEmployeeProfile.workingProfile
                        .positionManage.posManageName
                     : ""
                  : "",
               "TextArea"
               )}

               {this.inputForm(
               "ตําแหน่งทางวิชาการ",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.workingProfile
                     .positionTechnical.posTechnicalName
                     ? detailProfile.fetchEmployeeProfile.workingProfile
                        .positionTechnical.posTechnicalName
                     : ""
                  : "",
               "TextArea"
               )}

               {this.inputForm(
               "วันที่บรรจุ",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.employDate
                     ? checkType(detailProfile.fetchEmployeeProfile.employDate)
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "อายุงานที่บรรจุ",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.employDate
                     ? pushAgeWork(detailProfile.fetchEmployeeProfile.employDate)
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "เลขที่ใบประกอบวิชาชีพ",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.licenseNo
                     ? detailProfile.fetchEmployeeProfile.licenseNo
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "วันที่หมดอายุ",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.licenseExpirationDate
                     ? checkType(
                        detailProfile.fetchEmployeeProfile.licenseExpirationDate
                     )
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "สถานะสิทธิรักษาพยาบาล",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.benefits
                     ? checkType(detailProfile.fetchEmployeeProfile.benefits)
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "เลข HN โรงพยาบาลจุฬาลงกรณ์",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.hnNo
                     ? detailProfile.fetchEmployeeProfile.hnNo
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "เลข HN โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา",
               detailProfile.fetchEmployeeProfile
                  ? detailProfile.fetchEmployeeProfile.hnNo_somdej
                     ? detailProfile.fetchEmployeeProfile.hnNo_somdej
                     : ""
                  : "",
               "input"
               )}

               {this.inputForm(
               "สิทธิการจอดรถ",
               detailProfile.fetchEmployeeProfile
                  ? this.checkRefCarpark(detailProfile.fetchEmployeeProfile)
                  : "",
               "TextArea"
               )}
            </>
            <Col xs={24} md={24} className="mb-2">
               <strong>หมายเหตุ</strong>
               <p style={{ color: "#a2a2a2" }}>
               * หากพบว่าข้อมูลของท่านไม่ถูกต้อง
               สามารถติดต่อขอปรับปรุงข้อมูลกับหน่วยงาน HR ต้นสังกัดของท่าน ดังนี้
               <br></br>- สำนักงานบริหารทรัพยากรบุคคล (สบค.)
               ติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 2256 4058<br></br>-
               โรงพยาบาลจุฬาลงกรณ์ ติดต่อได้ที่ Call Center
               ของฝ่ายบริหารทรัพยากรบุคคล 0 2256 4000 ต่อ 4747<br></br>-
               โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา
               ติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 38320 200 ต่อ 23419
               </p>
            </Col>
         </Row>
         </TabPane>
    );
  };

  async componentDidMount() {
    await this.fetchProfile();
  }

  render() {
    const { history, location, match, staticContext } = this.props;
    const {
      detailProfile,
      detailEmployee,
      detailEmployeeDisplayConfig,
      loadingFullpage,
    } = this.state;

    console.log("checkdata detailProfile", detailProfile)
    console.log("checkdata detailEmployee", detailEmployee)
    console.log("checkdata detailEmployeeDisplayConfig", detailEmployeeDisplayConfig)
    return (
      <Container match={match}>
        {detailProfile && detailEmployee && detailEmployeeDisplayConfig && (
          <Spin spinning={loadingFullpage} delay={500}>
            <div className="card-container" id="page-profile">
              <div className="px-5 py-1 card-bg-green">
                {detailProfile.length !== 0 && (
                  <Tabs
                    type="card"
                    style={{ borderBottom: "6px solid #d7222a" }}
                    className="my-4"
                  >
                    {this.tabsOne()}
                  </Tabs>
                )}
              </div>
            </div>
          </Spin>
        )}
      </Container>
    );
  }
}

ProFileDetail.propTypes = {
  //
};

export default withApollo(ProFileDetail);
